export default "__VITE_ASSET__DMDjpX80__"